import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAggregatingOperation implements BaseEnumType {
  private static allValues: EnumAggregatingOperation[] = []; // make sure this is top-most
  
  public static none = new EnumAggregatingOperation(0, "None", "enum_aggregating_operation_none");
  public static sum = new EnumAggregatingOperation(1, "Sum", "enum_aggregating_operation_sum");
  public static highest = new EnumAggregatingOperation(2, "Highest", "enum_aggregating_operation_highest");
  public static lowest = new EnumAggregatingOperation(3, "Lowest", "enum_aggregating_operation_lowest");
  public static average = new EnumAggregatingOperation(4, "Average", "enum_aggregating_operation_average");
  public static count = new EnumAggregatingOperation(5, "Count", "enum_aggregating_operation_count");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAggregatingOperation.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumAggregatingOperation.none; }
  public isSum() { return this === EnumAggregatingOperation.sum; }
  public isHighest() { return this === EnumAggregatingOperation.highest; }
  public isLowest() { return this === EnumAggregatingOperation.lowest; }
  public isAverage() { return this === EnumAggregatingOperation.average; }
  public isCount() { return this === EnumAggregatingOperation.count; }

  public static getValues(): readonly EnumAggregatingOperation[] {
    return EnumAggregatingOperation.allValues;
  }

  public static getValuesExcept0(): readonly EnumAggregatingOperation[] {
    return EnumAggregatingOperation.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAggregatingOperation {
    const found = EnumAggregatingOperation.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAggregatingOperation - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAggregatingOperation): EnumAggregatingOperation {
    const found = name ? EnumAggregatingOperation.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAggregatingOperation - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAggregatingOperation>): boolean {
    return this.key === other?.key;
  }
}